import { productModule } from './views/product/module';

export const mastersModule = {
  modules: {
    product: productModule,
  },
};
